"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedInterestRateModel__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "initBorrowRate",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "initSupplyRate",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferStarted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "acceptOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "borrowRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "cash",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrows",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserves",
                type: "uint256",
            },
        ],
        name: "getBorrowRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "cash",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrows",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserves",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserveFactorMantissa",
                type: "uint256",
            },
        ],
        name: "getSupplyRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isInterestRateModel",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "secondsPerYear",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "rate",
                type: "uint256",
            },
        ],
        name: "setBorrowRate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "rate",
                type: "uint256",
            },
        ],
        name: "setSupplyRate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "supplyRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class FixedInterestRateModel__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(initBorrowRate, initSupplyRate, overrides) {
        return super.getDeployTransaction(initBorrowRate, initSupplyRate, overrides || {});
    }
    deploy(initBorrowRate, initSupplyRate, overrides) {
        return super.deploy(initBorrowRate, initSupplyRate, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.FixedInterestRateModel__factory = FixedInterestRateModel__factory;
FixedInterestRateModel__factory.bytecode = _bytecode;
FixedInterestRateModel__factory.abi = _abi;
//# sourceMappingURL=FixedInterestRateModel__factory.js.map